import { render } from "./member-list.vue?vue&type=template&id=7c44260d"
import script from "./member-list.vue?vue&type=script&lang=ts"
export * from "./member-list.vue?vue&type=script&lang=ts"
script.render = render

export default script